module.exports = __webpack_public_path__ + "static/img/paypal-5.51ebe14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/help/paypal-5.png
// module id = +RAc
// module chunks = 1